<template>
  <div class="customer-level-container default-table">
    <div v-for="(item,key) in mapTable" :key="key">
      <div class="divide-title"><span></span>{{item.label}}</div>
      <el-table :data="item.table" style="width: 100%" border>
        <el-table-column prop="date" label="梯度">
          <template slot-scope="{row,$index}">
            <template v-if="readonly">
              {{ row.show_end_money ? `${row.show_start_money}w &lt; x &lt;= ${row.show_end_money}w` :
              `x>${row.show_start_money}w` }}
            </template>
            <template v-else>
              <template v-if="$index<item.table.length-1">
                <el-input v-model="row.show_start_money" size="mini" class="input-c"
                          @change="changeValidate(key,row,$index)">
                  <template slot="append">w</template>
                </el-input>
                &lt; x &lt;=
                <el-input v-model="row.show_end_money" size="mini" class="input-c"
                          @change="changeValidate(key,row,$index)">
                  <template slot="append">w</template>
                </el-input>
              </template>
              <template v-else>
                x >
                <el-input v-model="row.show_start_money" size="mini" class="input-c"
                          @change="changeValidate(key,row,$index)">
                  <template slot="append">w</template>
                </el-input>
              </template>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="返点" align="center">
          <template slot-scope="{row}">
            <template v-if="readonly">
              <div v-if="row.percent_rebate">{{ row.percent_rebate }} %</div>
              <span v-else>-</span>
            </template>
            <template v-else>
              <el-input v-model="row.percent_rebate" size="mini" class="input-c">
                <template slot="append">%</template>
              </el-input>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="折扣" align="center">
          <template slot-scope="{row}">
            <template v-if="readonly">
              <div v-if="row.percent_discount">{{ row.percent_discount }} 折</div>
              <span v-else>-</span>
            </template>
            <template v-else>
              <el-input v-model="row.percent_discount" size="mini" class="input-c">
                <template slot="append">折</template>
              </el-input>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="level" label="客户等级" align="center">
          <template slot-scope="{row}">
            <template v-if="readonly">
              <div v-if="row.level">{{ row.level }}</div>
              <span v-else>-</span>
            </template>
            <template v-else>
              <el-input v-model="row.level" size="mini" class="input-c"/>
            </template>
          </template>
        </el-table-column>
        <template v-if="!readonly">
          <el-table-column label="校验" align="center" show-overflow-tooltip>
            <template slot-scope="{row}">
              <span style="color: red;">{{ row.error }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="50px">
            <template slot-scope="{row,$index}">
              <span v-if="$index<item.table.length-1" style="color: #ff3176;"
                    @click="handelDelete(key,$index)">删除</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <div class="plus" v-if="userAuth.can_save_customer_level&&!readonly" >
        <p @click="handelPlus(key)"><i class="el-icon-circle-plus"/></p>
      </div>
    </div>
    <div v-if="userAuth.can_save_customer_level" style="margin: 40px;text-align: center;">
      <el-button v-if="readonly" type="primary" @click="readonly=false">编辑</el-button>
      <el-button v-else type="primary" @click="handelSave">保存设置</el-button>
    </div>
  </div>
</template>

<script>
  import {levelConfig, saveLevelConfig} from "../../api/customerYearFrame";

  const MapPolicyType = {
    TYPE_KOL: 'KOL',
    TYPE_KOC: 'KOC',
  };
  const MapPolicySubtype = {
    TYPE_MEAS_THE: 'THE',
    TYPE_MEAS_ADD: 'ADD',
    TYPE_MEAS_OTHER: 'OTHER',
  };
  export default {
    name: "index",
    data() {
      return {
        readonly: true,
        mapTable: {
          kolThe: {
            label: 'KOL保量政策',
            table: [],
            fixed: {type_ko: MapPolicyType.TYPE_KOL, type_meas: MapPolicySubtype.TYPE_MEAS_THE}
          },
          kolAdd: {
            label: 'KOL累量政策',
            table: [],
            fixed: {type_ko: MapPolicyType.TYPE_KOL, type_meas: MapPolicySubtype.TYPE_MEAS_ADD}
          },
          kocThe: {
            label: 'KOC保量政策',
            table: [],
            fixed: {type_ko: MapPolicyType.TYPE_KOC, type_meas: MapPolicySubtype.TYPE_MEAS_THE}
          },
        },
      }
    },
    computed: {
      userAuth() {
        return this.$store.getters.getUserAuth;
      },
    },
    mounted() {
      this.init()
    },
    methods: {
      async init() {
        this.readonly = true
        const responseKOL = await levelConfig({
          type_ko: MapPolicyType.TYPE_KOL,
          type_meas: MapPolicySubtype.TYPE_MEAS_THE
        });
        const responseKOC = await levelConfig({
          type_ko: MapPolicyType.TYPE_KOC,
          type_meas: MapPolicySubtype.TYPE_MEAS_THE
        });
        const responseKOLAdd = await levelConfig({
          type_ko: MapPolicyType.TYPE_KOL,
          type_meas: MapPolicySubtype.TYPE_MEAS_ADD
        });
        this.mapTable.kocThe.table = this.setDefaultError(responseKOC.model || [])
        this.mapTable.kolAdd.table = this.setDefaultError(responseKOLAdd.model || [])
        this.mapTable.kolThe.table = this.setDefaultError(responseKOL.model || [])
      },
      async handelSave() {
        let error = false
        let data = [];
        for (const key in this.mapTable) {
          const item = this.mapTable[key]
          const label = item.label
          for (let i = 0; i < item.table.length; i++) {
            const rowIndex = i + 1;
            const row = item.table[i]
            this.changeValidate(key, item.table[i], i)
            if (row.error) {
              error = `${label} ${rowIndex}行 ${row.error}`;
            }
            if (row.percent_rebate > 100) {
              error = `${label} ${rowIndex}行 返点比例不能大于100%`;
            }
            if (row.percent_discount > 100) {
              error = `${label} ${rowIndex}行 折扣不能大于100`;
            }
            if (!row.percent_discount && !row.percent_rebate) {
              error = `${label} ${rowIndex}行 折扣或者返点比例 必须填写其一`;
            }
            if (!row.level) {
              error = `${label} ${rowIndex}行 客户等级必填`;
            }
            if (!row.show_start_money) {
              error = `${label} ${rowIndex}行 开始金额必填`;
            }
            if (i < item.table.length - 1 && !row.show_end_money) {
              error = `${label} ${rowIndex}行 结束金额必填`;
            }

            row.start_money = this.$bigNumber(row.show_start_money).multipliedBy(10000).toNumber();
            row.end_money = this.$bigNumber(row.show_end_money).multipliedBy(10000).toNumber();
            const datum = {...{}, ...row}
            data.push({...datum, ...item.fixed});
          }
        }
        if (error) {
          this.$message.warning(error)
          return;
        }

        const response = await saveLevelConfig({data})
        if (!response.success) {
          this.$message.error(response.message || '系统服务异常');
          return false
        }
        this.$message.success('操作成功')
        this.init()
      },
      /**
       * 删除
       * @param key
       * @param index
       */
      handelDelete(key, index) {
        this.mapTable[key].table.splice(index, 1)
      },
      /**
       * 新增
       * @param key
       */
      handelPlus(key) {
        this.mapTable[key].table.push({
          "type_ko": null,
          "type_meas": null,
          "start_money": null,
          "end_money": null,
          "percent_rebate": null,
          "percent_discount": null,
          "level": null,
          "show_start_money": null,
          "show_end_money": null
        })
      },
      setDefaultError(data) {
        data.map(_ => {
          _.error = null
        })
        return data;
      },
      /**
       * @param key
       * @param row
       * @param index
       */
      changeValidate(key, row, index) {
        let error = null
        const table = this.mapTable[key].table
        const row_last = table[index - 1] || false
        const row_next = table[index + 1] || false
        row.show_start_money = parseFloat(row.show_start_money)
        row.show_end_money = parseFloat(row.show_end_money)

        if (row_last && row_last.show_end_money != row.show_start_money) {
          error = `${row_last.level}、${row.level || '其他行'}之间出现空档`
        }

        if (row_next && row.show_end_money != row_next.show_start_money) {
          error = `${row.level}、${row_next.level || '其他行'}之间出现空档`
        }

        if (row.show_end_money && row.show_start_money == row.show_end_money) {
          error = '开始结束金额相同'
        }

        if (row.show_end_money && row.show_start_money > row.show_end_money) {
          error = '开始金额大于结束金额！'
        }

        row.error = error;
      },
    }
  }
</script>

<style lang="scss">
  .customer-level-container {
    text-align: unset;
    padding: 0 24px;

    .divide-title {
      font-size: 16px;
      font-weight: 600;
      color: #45474d;
      display: flex;
      align-items: center;
      margin: 30px 0 10px;

      span {
        width: 2px;
        height: 12px;
        background: #fe346e;
        margin-right: 8px;
      }
    }

    .input-c {
      width: 70px;

      input {
        padding: 4px;
        height: 18px;
        line-height: 18px;
      }

      .el-input-group__append {
        padding: 0 1px;
      }
    }

    .plus {
      display: flex;
      align-items: center;
      justify-content: center;

      p {
        width: 50px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-block-start: 0;
        margin-block-end: 0;
        background-color: #ff3176;
        border-bottom-right-radius: 50%;
        border-bottom-left-radius: 50%;
        cursor: pointer;

        i {
          color: #fff;
          font-size: 14px;
        }
      }
    }
  }
</style>
